import { DataModel } from "@toolpad/core/Crud";

import { IRoleDto } from "../generated/api-client";
import { nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";

type RoleDtoDataModel = IRoleDto & DataModel;

export default function RolesPage() {
  const columns: MagicCrudFields<IRoleDto>[] = [
    {
      field: nameof<IRoleDto>("id"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IRoleDto>("name"),
      type: "string",
    },
    {
      field: nameof<IRoleDto>("displayName"),
      type: "string",
    },
  ];

  return (
    <MagicCrud<RoleDtoDataModel>
      name="role"
      apiUrl="roles"
      columns={columns}
      appUrl="/roles"
    />
  );
}
